import React from 'react';
import { Grid, LinearProgress, Button, Link } from '@material-ui/core';

export const Layout = (props) => {
    const progress = props.header? props.header.progress.value : null;
    const imgSrc = props.body? props.body.img.src : null;
    const slot = props.body ? props.body.slot : null;
    const buttonAction = props.footer && props.footer.button.action ? props.footer.button.action : ()=>{};
    const buttonDisabled = props.footer && props.footer.button.disabled ? props.footer.button.disabled : false;
    const buttonText = props.footer? props.footer.button.text : null;
    const buttonNavigate = props.footer? props.footer.button.link : null;
    const containerClass = `onboarding layout-grid${props.tieneFooter ? " con-footer" : ""}`;
    
    return (
        <Grid container className={containerClass}>
            <Grid item xs={12} sm={12} className={"layout-progress " + (progress || 'none')}>
                <LinearProgress variant="determinate" value={progress} className="progress"/>
            </Grid>
            <Grid item container xs={12} sm={6} className="layout-grow" alignItems="center" justify="center">
                <img src={imgSrc} className="layout-img"/>
                {props.children}
            </Grid>
            <Grid item container xs={12} sm={6} className="layout-grow" alignItems="center" justify="center">
                <Grid item>
                    {slot}    
                </Grid>
                {
                    props.footer &&
                    <Grid item className="btn-container">
                        <Button onClick={buttonAction} href={buttonNavigate || ""} variant="contained" 
                            data-wow-duration="1000ms" data-wow-delay="400ms" 
                            className="btn" disabled={buttonDisabled}>
                            {buttonText}</Button>
                    </Grid>
                }
            </Grid>
        </Grid>
    );
}



// WEBPACK FOOTER //
// ./src/components/OnBoarding/layout/Layout.js